import React from 'react';
import { motion } from 'framer-motion';
import { Settings, TrendingUp, ShieldCheck, Landmark } from 'lucide-react';
export function SolutionSection() {
  const solutions = [{
    icon: <Settings className="w-6 h-6 text-white" data-id="element-237" />,
    title: 'Cómo funciona el crédito',
    desc: 'Entiende los 5 factores exactos que componen tu score y cómo dominarlos.'
  }, {
    icon: <TrendingUp className="w-6 h-6 text-white" data-id="element-238" />,
    title: 'Cómo subir el score estratégicamente',
    desc: 'Tácticas probadas para ver incrementos reales en tu puntaje mes a mes.'
  }, {
    icon: <ShieldCheck className="w-6 h-6 text-white" data-id="element-239" />,
    title: 'Cómo evitar errores comunes',
    desc: 'Protege tu historial de las trampas que la mayoría de las personas cometen.'
  }, {
    icon: <Landmark className="w-6 h-6 text-white" data-id="element-240" />,
    title: 'Cómo mantener estabilidad financiera',
    desc: 'Crea un sistema automático para que tu crédito trabaje para ti, no en tu contra.'
  }];
  return <section className="py-20 bg-white" data-id="element-241">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-242">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-243">
          <motion.div className="flex-1" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-244">
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-black mb-6" data-id="element-245">
              Este no es un ebook… <br data-id="element-246" />
              <span className="text-brand-green" data-id="element-247">es un sistema práctico</span>
            </h2>
            <p className="text-lg text-gray-600 mb-8" data-id="element-248">
              No encontrarás teoría aburrida ni relleno. SCORE 700 es una guía
              directa al grano que te enseña paso a paso exactamente lo que
              necesitas hacer.
            </p>

            <div className="space-y-6" data-id="element-249">
              {solutions.map((item, index) => <motion.div key={index} className="flex gap-4 items-start" initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} data-id="element-250">
                  <div className="w-12 h-12 rounded-lg bg-brand-green flex items-center justify-center shrink-0 shadow-md" data-id="element-251">
                    {item.icon}
                  </div>
                  <div data-id="element-252">
                    <h4 className="text-xl font-bold text-brand-black mb-1" data-id="element-253">
                      {item.title}
                    </h4>
                    <p className="text-gray-600" data-id="element-254">{item.desc}</p>
                  </div>
                </motion.div>)}
            </div>
          </motion.div>

          <motion.div className="flex-1 relative" initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-255">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-256">
              <img src="https://cdn.magicpatterns.com/uploads/h9CZmnXJxmnMwncjGk4WxE/carrusel_imagen_4.png" alt="Beneficios principales del Sistema SCORE 700" className="w-full h-auto object-cover" data-id="element-257" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}